import React from "react";
import { Route, Routes } from "react-router-dom";
import { ZonesPage } from "./pages/zones-page/sidebar";
import { ArcBaseContent, ArcBaseSidebar } from "@src/core/components";
import { ArcGoogleMap } from "@src/core/controllers";
import ZonesMap from "./pages/zones-page/map";
import { ArcStack } from "@src/core/ui";
import { CreateZonePage } from "./pages/create-zone";
import { EditZonePage } from "./pages/edit-zone";
import { useGetZonesQuery } from "@src/core/features";

const ZonesMapWrapper: React.FC = () => {
  const { data: zones } = useGetZonesQuery();
  return <ZonesMap zones={zones ?? []} />;
};

const ZonesFeature: React.FC = () => {
  return (
    <ArcStack direction='row'>
      <ArcBaseSidebar>
        <Routes>
          <Route path="" element={<ZonesPage />} />
          <Route path="create" element={<CreateZonePage />} />  
          <Route path="edit/:id" element={<EditZonePage />} />
        </Routes>
      </ArcBaseSidebar>
      <ArcBaseContent>
        <ArcGoogleMap>
          <ZonesMapWrapper />
        </ArcGoogleMap>
      </ArcBaseContent>
    </ArcStack>
  );
};

export default ZonesFeature;
